import { createRoute } from '@tanstack/react-router'
import { Logs } from '@/pages/Logs'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
    getParentRoute: () => rootRoute,
    path: '/logs',
    component: Logs,
})
